module.exports = __webpack_public_path__ + "static/img/04_11.5ba554e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/tips/04_11.png
// module id = SLZn
// module chunks = 1